import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Footprints,
  HeartHandshake,
  Users,
  HandHeart,
  ArrowUpRight,
} from "lucide-react";
import { AUDIENCE } from "../data/mock";

const ICONS = { Footprints, HeartHandshake, Users, HandHeart };

const Audience = () => {
  const [active, setActive] = useState(0);
  const ActiveIcon = ICONS[AUDIENCE[active].icon] || Footprints;

  return (
    <section id="audience" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <p className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--rc-purple))] font-medium">
            Where you are matters
          </p>
          <h2 className="font-serif-display mt-3 text-[36px] md:text-[46px] leading-[1.08] font-semibold text-[hsl(var(--rc-deep))]">
            I am a person who is…
          </h2>
          <p className="mt-4 text-[16px] leading-[1.7] text-[hsl(var(--rc-slate))]">
            Choose the path that best describes where you are right now. We’ll connect you with the right peer specialist and resources.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 flex flex-col">
            {AUDIENCE.map((a, i) => {
              const Icon = ICONS[a.icon] || Footprints;
              const isActive = active === i;
              return (
                <button
                  key={a.title}
                  onClick={() => setActive(i)}
                  className={`text-left flex items-center gap-4 px-5 py-5 border-l-2 transition-all duration-300 ${
                    isActive
                      ? "border-[hsl(var(--rc-purple))] bg-[hsl(var(--rc-purple-soft))]/50"
                      : "border-[hsl(var(--border))] hover:border-[hsl(var(--rc-purple))]/60 hover:bg-[hsl(var(--secondary))]/60"
                  }`}
                >
                  <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors ${
                      isActive
                        ? "bg-[hsl(var(--rc-deep))] text-white"
                        : "bg-[hsl(var(--secondary))] text-[hsl(var(--rc-purple))]"
                    }`}
                  >
                    <Icon className="w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <div
                      className={`font-serif-display text-[19px] font-semibold ${
                        isActive ? "text-[hsl(var(--rc-deep))]" : "text-[hsl(var(--rc-charcoal))]"
                      }`}
                    >
                      {a.title}
                    </div>
                  </div>
                  <ArrowUpRight
                    className={`w-4 h-4 transition-all ${
                      isActive
                        ? "text-[hsl(var(--rc-purple))] translate-x-0"
                        : "text-[hsl(var(--muted-foreground))] -translate-x-1 opacity-60"
                    }`}
                  />
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-7">
            <div
              key={active}
              className="rc-reveal bg-[hsl(var(--rc-paper))] border border-[hsl(var(--border))] rounded-2xl p-8 md:p-10 h-full flex flex-col"
            >
              <div className="w-12 h-12 rounded-xl bg-[hsl(var(--rc-deep))] text-white flex items-center justify-center mb-6">
                <ActiveIcon className="w-5 h-5" />
              </div>
              <h3 className="font-serif-display text-[28px] md:text-[32px] font-semibold text-[hsl(var(--rc-deep))]">
                {AUDIENCE[active].title}
              </h3>
              <p className="mt-4 text-[16px] leading-[1.75] text-[hsl(var(--rc-slate))]">
                {AUDIENCE[active].description}
              </p>
              <div className="mt-auto pt-8">
                <Link
                  to={`/need-help#${AUDIENCE[active].anchor}`}
                  className="inline-flex items-center gap-2 px-6 h-11 rounded-full bg-[hsl(var(--rc-deep))] text-white text-[14px] font-medium hover:bg-[hsl(var(--rc-purple))] transition-colors"
                >
                  {AUDIENCE[active].cta}
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Audience;
